// api接口的统一出口
import loginhome from '@/api/login';//登录模块接口

// 导出接口
export default {
    loginhome,   //登录模块接口
}

